import LogRocket from 'logrocket';

if ( process.env.NODE_ENV === 'production' ) {
  LogRocket.init('054cj7/child-arrangements-calendar');
}